import React from "react";
import { Affix, Group } from "@mantine/core";

import { CustomScrollbars } from "@piqnt/runtime-core/react/CustomScrollbars";
import { useMiddleware } from "@piqnt/runtime-core/react/ReactMount";

import {
  affixPosition,
  affixStyle,
  dividerStyle,
  panelStyle,
  sectionStyle,
  topSpace,
} from "@piqnt/runtime-core/react/OutlineStyle";

import { OutlineContext } from "./OutlineContext";
import { SelectionView } from "./SelectionView";
import { WorldSubtree } from "./WorldView";

export const LiveOutlinePanel = () => {
  const { context } = useMiddleware<OutlineContext>();
  if (context.activity?.value !== "mode:play") return;
  return (
    <Affix position={affixPosition} style={affixStyle}>
      <div style={panelStyle}>
        <div style={topSpace}></div>
        <Group justify="end" gap={8} m={8}></Group>
        <div style={dividerStyle} />
        <div style={sectionStyle}>
          <CustomScrollbars>
            <SelectionView />
          </CustomScrollbars>
        </div>
        <div style={dividerStyle} />
        <div style={sectionStyle}>
          <CustomScrollbars>
            <WorldSubtree />
          </CustomScrollbars>
        </div>
      </div>
    </Affix>
  );
};
